<style lang="scss" scoped>
.header-input {
  scroll-margin-top: 30px;
}
.header-input-form {
  background-color: #eee;
  position: relative;
  padding: 15px 15px 1px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}
.header-input-preview {
  h2 {
    border-bottom: 3px solid #8da;
    font-size: 24px;
    padding-bottom: 5px;
    margin: 0 0 10px;
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.3;
    padding: 3px 9px;
    margin: 0 1em 10px 0;
    color: #333;
    border-left: 5px solid #8da;
  }
  h4 {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.3;
    padding: 3px 9px;
    margin: 0 1em 10px 0;
    color: #333;
    border-left: 2px solid #8da;
  }
  h5 {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.3;
    padding: 3px 9px;
    margin: 0 1em 10px 0;
    color: #333;
  }
}
</style>

<template>
  <div class="header-input">
    <div class="header-input-form" v-if="isEditing">
      <h2>見出し</h2>
      <div class="form-group">
        <input class="form-control" type="text" v-model="text" />
      </div>
      <div class="form-group">
        <select class="form-select" v-model="type">
          <option value="h2">大見出し(h2)</option>
          <option value="h3">小見出し(h3)</option>
          <option value="h4">小見出し(h4)</option>
          <option value="h5">小見出し(h5)</option>
        </select>
      </div>
      <div class="form-group">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="header-input-preview input-preview" v-else>
      <div v-if="type == 'h2'">
        <h2>{{ text }}</h2>
      </div>
      <div v-if="type == 'h3'">
        <h3>{{ text }}</h3>
      </div>
      <div v-if="type == 'h4'">
        <h4>{{ text }}</h4>
      </div>
      <div v-if="type == 'h5'">
        <h5>{{ text }}</h5>
      </div>
      <footer-menu
        :onBeginEdit="onBeginEdit"
        :onDeleteInput="onDeleteInput"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :onPullUpGroup="type == 'h2' ? onPullUpGroup : null"
        :onPullDownGroup="type == 'h2' ? onPullDownGroup : null"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';
export default {
  props: {
    value: {},
    index: Number,
    id: String,
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          text: this.text,
          type: this.type,
        },
        action: 'header',
        id: this.id,
      };
    },
    valid() {
      return this.text.length;
    },
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (!this.valid) {
        alert('見出しを入力してください。');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
    onPullUpGroup() {
      bus.$emit('pull-up-group', this.index);
    },
    onPullDownGroup() {
      bus.$emit('pull-down-group', this.index);
    },
  },
  components: {
    'footer-menu': footerMenu,
  },
  mounted() {
    this.type = this.value.type;
    this.text = this.value.text;
  },
  data() {
    return {
      isEditing: false,
      type: '',
      text: '',
    };
  },
};
</script>
